import PageLayout from "@components/PageLayout";
import { HighGrowthVault } from "@components/V2/Vault";
import { YieldVaultProider } from "@providers/YieldVaultProvider";
import { getVaultChartData } from "@services/index";
import { fetchStrapiData } from "@services/strapi";
import {
  QueryClient,
  dehydrate,
  HydrationBoundary,
} from "@tanstack/react-query";

import React from "react";

export const getStaticProps = async () => {
  const queryClient = new QueryClient();

  // Prefetch APR data for hgeth
  await queryClient.prefetchQuery({
    queryKey: ["apr-data", "hgeth"],
    queryFn: async () => {
      const r = await getVaultChartData("hgeth");
      return r.data;
    },
    staleTime: 1 * 60 * 60 * 1000, // Cache for 1 hour
  });

  const res = await fetchStrapiData("strategy-allocations");

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      page: {
        data: {
          cmsAllocations: (() => {
            if (res?.data?.length > 0) {
              const vaultData = res.data.find(
                (data: any) =>
                  data?.attributes?.vault_name === "high_growth_vault"
              );

              return vaultData?.attributes || [];
            }
            return [];
          })(),
        },
      },
    },
  };
};

const YieldVaultPage = (props: { page: any; dehydratedState: any }) => {
  return (
    <HydrationBoundary state={props.dehydratedState}>
      <PageLayout extraMarginTop={false}>
        <YieldVaultProider
          data={{ cmsAllocations: props.page.data.cmsAllocations }}
        >
          <HighGrowthVault />
        </YieldVaultProider>
      </PageLayout>
    </HydrationBoundary>
  );
};

export default YieldVaultPage;
